import { Box, Typography } from '@mui/material';
import { styled } from '@mui/material/styles';
export const PlaceholderPageContainer = styled(Box)({
  display: 'flex',
  flexDirection: 'column',
  justifyContent: 'center',
  alignItems: 'center',
  width: '100%',
  height: '70vh',
});
export const PlaceholderPageText = styled(Typography)<{ textType?: 'primary' | 'secondary' | 'error' }>(
  ({ textType = 'primary', theme }) => {
    switch (textType) {
      case 'secondary':
        return {
          fontSize: 16,
          fontWeight: 500,
          color: theme.palette.primary.main,
          [theme.breakpoints.down('sm')]: {
            fontSize: 12,
          },
        };
      case 'primary':
      default:
        return {
          fontSize: 24,
          textAlign: 'center',
          fontWeight: 600,
          color: theme.palette.text.primary,
          [theme.breakpoints.down('sm')]: {
            fontSize: 16,
          },
        };
    }
  },
);
export const PlaceholderPageSettingsIcon = styled('img')(({ theme }) => ({
  width: 100,
  height: 100,
  marginBottom: 20,
  [theme.breakpoints.down('sm')]: {
    width: 50,
    height: 50,
  },
}));
